var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgVideoOff = function SvgVideoOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z",
    fill: "#202020"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 38c9.941 0 18-8.059 18-18 0-6.319-3.256-11.877-8.181-15.089L23.978 15.03c.201.332.31.716.31 1.111v1.706l4.683-2.344a.71.71 0 0 1 .693.033.693.693 0 0 1 .336.605v8.572a.683.683 0 0 1-.072.325.721.721 0 0 1-.963.32l-4.676-2.34v1.7a2.146 2.146 0 0 1-2.146 2.141h-4.994l-5.306 9.192A17.924 17.924 0 0 0 20 38Zm-9.886-2.956 4.725-8.186H12.14a2.14 2.14 0 0 1-2.14-2.14V16.14A2.14 2.14 0 0 1 12.14 14h10.036c.028 0 .057.001.085.003l5.824-10.09A17.925 17.925 0 0 0 20 2C10.059 2 2 10.059 2 20c0 6.29 3.226 11.826 8.114 15.044ZM40 20c0 11.046-8.954 20-20 20S0 31.046 0 20 8.954 0 20 0s20 8.954 20 20Z",
    fill: "#fff"
  })));
};
export default SvgVideoOff;